import * as yup from 'yup';

export const rooftop = yup.object().shape({
  active: yup.boolean(),
  type: yup
    .number()
    .typeError('Este campo es obligatorio')
    .when('active', {
      is: true,
      then: yup
        .number()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio')
    })
});
